/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_total = /** @type {(inputs: {}) => string} */ () => {
	return `Celkem`
};

const da_total = /** @type {(inputs: {}) => string} */ () => {
	return `Total`
};

const de_total = /** @type {(inputs: {}) => string} */ () => {
	return `Gesamt`
};

const en_total = /** @type {(inputs: {}) => string} */ () => {
	return `Total`
};

const es_total = /** @type {(inputs: {}) => string} */ () => {
	return `Total`
};

const fr_total = /** @type {(inputs: {}) => string} */ () => {
	return `Total`
};

const hu_total = /** @type {(inputs: {}) => string} */ () => {
	return `Összesen`
};

const it_total = /** @type {(inputs: {}) => string} */ () => {
	return `Totale`
};

const nl_total = /** @type {(inputs: {}) => string} */ () => {
	return `Totaal`
};

const pl_total = /** @type {(inputs: {}) => string} */ () => {
	return `Razem`
};

const pt_total = /** @type {(inputs: {}) => string} */ () => {
	return `Total`
};

const sv_total = /** @type {(inputs: {}) => string} */ () => {
	return `Totalt`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const total = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.total(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("total", locale)
	if (locale === "cs") return cs_total(inputs)
	if (locale === "da") return da_total(inputs)
	if (locale === "de") return de_total(inputs)
	if (locale === "en") return en_total(inputs)
	if (locale === "es") return es_total(inputs)
	if (locale === "fr") return fr_total(inputs)
	if (locale === "hu") return hu_total(inputs)
	if (locale === "it") return it_total(inputs)
	if (locale === "nl") return nl_total(inputs)
	if (locale === "pl") return pl_total(inputs)
	if (locale === "pt") return pt_total(inputs)
	return sv_total(inputs)
};